import axios from "axios";
import { analyticsApi, api, api_go, api_reports_go, api_v1_go, e360Api, reportsApi } from "../modules/Axios/api";

export const DatasnapRequest = axios.create({
    baseURL: process.env.DATASNAP_API_URL,
    headers: {
        "Content-Type": `text/plain;charset=UTF-8`,
        "If-Modified-Since": `Mon, 1 Oct 1990 05:00:00 GMT`,
    },
});

export const NodejsRequest = axios.create();

export const NodejsAdonis = axios.create({
    baseURL: process.env.RASTERSERVER_API_URL,
});

export const NodejsAdonisMorpheus = axios.create({
    baseURL: process.env.URL_RASTERSERVER_MORPHEUS,
});

export const setDefaultSessionTokenHeader = (
    accessToken: string,
    refreshToken: string,
) => {
    DatasnapRequest.defaults.headers.common["Authorization"] =
        `Bearer ${accessToken}`;
    NodejsAdonis.defaults.headers.common["Authorization"] =
        `Bearer ${accessToken}`;
    NodejsAdonisMorpheus.defaults.headers.common["Authorization"] =
        `Bearer ${accessToken}`;
    api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    reportsApi.defaults.headers.common["Authorization"] =
        `Bearer ${accessToken}`;
    analyticsApi.defaults.headers.common["Authorization"] =
        `Bearer ${accessToken}`;
    // O e360 tira usuário, empresa e sistema do próprio token (JOR4-7826).
    e360Api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    api_go.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    api_v1_go.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    api_reports_go.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
};

export const clearDefaultSessionTokenHeader = () => {
    delete DatasnapRequest.defaults.headers.common["Authorization"];
    delete NodejsAdonis.defaults.headers.common["Authorization"];
    delete NodejsAdonisMorpheus.defaults.headers.common["Authorization"];
    delete api.defaults.headers.common["Authorization"];
    delete reportsApi.defaults.headers.common["Authorization"];
    delete analyticsApi.defaults.headers.common["Authorization"];
    delete e360Api.defaults.headers.common["Authorization"];
    delete api_go.defaults.headers.common["Authorization"];
    delete api_v1_go.defaults.headers.common["Authorization"];
    delete api_reports_go.defaults.headers.common["Authorization"];
};
